import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/common";
import Seo from "@/components/Seo";
import PromoBanner from "@/components/PromoBanner";

const DOCS = {
    terms: "Membership Terms & Conditions",
    privacy: "Privacy Policy",
    "community-rules": "Community Rules & Member Conduct",
    safety: "Safety & Participation Agreement",
};

const SEO = {
    terms: "Read the Single Social Club membership terms and conditions — plans, billing, cancellation, and member responsibilities.",
    privacy: "How Single Social Club collects, uses, and protects your personal information and identity verification data.",
    "community-rules": "Our community rules and member conduct standards that keep Single Social Club respectful and safe for verified singles.",
    safety: "The Single Social Club safety and participation agreement — how we verify members and what to expect at real-world outings.",
};

export default function LegalDoc({ slug }) {
    const [html, setHtml] = useState("<p>Loading…</p>");
    useEffect(() => {
        let alive = true;
        fetch(`/legal/${slug}.html`)
            .then((r) => (r.ok ? r.text() : Promise.reject()))
            .then((t) => { if (alive) setHtml(t); })
            .catch(() => { if (alive) setHtml("<p>This document is temporarily unavailable.</p>"); });
        return () => { alive = false; };
    }, [slug]);

    return (
        <div className="min-h-screen bg-background text-foreground">
            <Seo title={DOCS[slug] || "Legal"} description={SEO[slug]} path={`/${slug}`} />
            <PromoBanner />
            <header className="border-b border-black/5">
                <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-4">
                    <Logo />
                    <Link to="/" className="text-sm text-muted-foreground hover:text-primary">Home</Link>
                </div>
            </header>
            <main className="mx-auto max-w-3xl px-5 py-12">
                <h1 className="font-display text-3xl font-700 tracking-tight text-primary sm:text-4xl" data-testid="legal-title">{DOCS[slug] || "Legal"}</h1>
                <article className="legal-prose mt-6" data-testid="legal-content" dangerouslySetInnerHTML={{ __html: html }} />
                <div className="mt-12 flex flex-wrap gap-x-5 gap-y-2 border-t border-black/5 pt-6 text-sm">
                    {Object.entries(DOCS).filter(([s]) => s !== slug).map(([s, t]) => (
                        <Link key={s} to={`/${s}`} className="text-accent hover:underline">{t}</Link>
                    ))}
                    <Link to="/faq" className="text-accent hover:underline">FAQ</Link>
                </div>
            </main>
        </div>
    );
}
